<div class="modal-container">
    <div class="modal-content">
        <div class="modal-header">
            <div class="titles">
                <span class="headline-bold" [class]="modalData?.header?.color">
                    {{ modalData?.header?.label }}
                </span>
                <br />
                <span class="subtitle">{{ modalData?.subheader }}</span>
            </div>
            <ion-icon [src]="'assets/icon/card/' + modalData?.image" class="xlarge"></ion-icon>
        </div>
        <span class="body-medium description">
            {{ modalData?.text }}
        </span>
    </div>
    <div class="buttons">
        <ion-button *ngFor="let button of modalData?.buttons" (click)="button.action()" class="primary-button">
            {{ button.label }}
        </ion-button>
    </div>
</div>
